import React from 'react';
import PropTypes from 'prop-types';

import { ButtonArrowState, PrimaryButton } from '@huggg/react-components';

import styles from './types.module.scss';

const Fulfil = props => {
  const { loading = false, onClick, isBlueHuggg = false } = props;

  const label = isBlueHuggg ? 'Open voucher' : 'Open gift card';

  return (
    <>
      <PrimaryButton
        onClick={onClick}
        data-test-id="button-visit-external"
        label={label}
        arrow={ButtonArrowState.None}
        loading={loading}
        className={styles.fulfilButton}
      />
    </>
  );
};

Fulfil.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isBlueHuggg: PropTypes.bool
};

export default Fulfil;
